import React from "react";
import InfoTooltip from "../../../../components/common/InfoTooltip";
import CustomSelect, {
  OptionType,
} from "../../../../components/form/CustomSelect";

export const randPostTimeOptions: OptionType[] = [
  {
    value: null,
    label: "-",
    description: "",
  },
  ...Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
    description: "",
  })),
];

interface RandPostHourSelectorProps {
  randomPostHours: number | null;
  onChange: (value: number | null) => void;
}

const RandPostHourSelector = ({
  randomPostHours,
  onChange,
}: RandPostHourSelectorProps) => {
  return (
    <div className="flex flex-col gap-1">
      <label
        htmlFor="rand-post-time-1"
        className="flex gap-2 items-center uppercase text-xs tracking-wide font-medium leading-6 text-gray-900"
      >
        Random Post Time
        <InfoTooltip
          id="rand-post-time"
          tooltip="Search engines, such as Google, like frequently updated websites and random publish times."
        />
      </label>
      <div className="text-[0.825rem] leading-5 text-gray-500">
        Generate a random post time between the run time and number of hours
        selected below.{" "}
        <div className="">
          Example: If your template run time is set 2:00 PM and you select 6
          hours, a random post time will be selected between 2:00 PM and 8:00
          PM.
        </div>
      </div>
      <div className="text-xs text-gray-600"></div>
      <CustomSelect
        label="Hours"
        placeholder="-"
        className="max-w-[7rem]"
        maxMenuHeight={100}
        isClearable={Boolean(randomPostHours)}
        options={randPostTimeOptions}
        selected={randPostTimeOptions.find(
          (option) => option.value === randomPostHours
        )}
        setSelected={(option) => {
          onChange(option?.value || null);
        }}
      />
    </div>
  );
};

export default RandPostHourSelector;
